import { Button, Modal } from "@material-ui/core";
import React, { memo } from "react";
import styles from "../timelineTop/TimelineTopModal.module.css";

interface TimelineTopModalProps {
    open: boolean;
    onClose: () => void;
    leftButtonClick: () => void;
    rightButtonClick: () => void;
    message: string;
    leftButtonText: string;
    rightButtonText: string;
}

function TimelineTopModal({
    open,
    onClose,
    leftButtonClick,
    leftButtonText,
    rightButtonClick,
    rightButtonText,
    message,
}: TimelineTopModalProps) {
    return (
        <Modal open={open} onClose={onClose}>
            <div className={styles.modalRoot}>
                <div className={styles.timelineModalDiv}>
                    {message}
                    <div className={styles.timelineTopModal}>
                        <Button
                            className={styles.btnDiv}
                            onClick={leftButtonClick}
                            style={{
                                color: "var(--white)",
                                backgroundColor: "#606060",
                            }}
                        >
                            {leftButtonText}
                        </Button>
                        <Button
                            className={styles.btnDiv}
                            onClick={rightButtonClick}
                            style={{
                                color: "var(--white)",
                                backgroundColor: "var(--studio-btn-bg)",
                            }}
                        >
                            {rightButtonText}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
export default memo(TimelineTopModal);
